import { Route } from 'react-router';
import PartnerManagerPage from '../../../modules/partnerManager';

export const PartnerManagerRouter = [
  <Route index element={<PartnerManagerPage />} />,
];
